_ = require('lodash')

GroupUploadDataService = ($http, $q) ->
  uploadS3:(file,url,data) ->
    defer = $q.defer()

    if !file || !url || !data
      defer.resolve ''
      defer.promise
      return

    urlUpload = data.key
    config = {
      'headers' : {
        'enctype': 'multipart/form-data'
        'Content-Type': undefined
      }
      transformRequest: angular.identity
    }

    fData = new FormData()
    for key, value of data
      fData.append(key,value)
    fData.append('file',file)
    $http.post(url, fData , config)
      .then (data) ->
        defer.resolve urlUpload
      , (data) ->
        defer.resolve ''
    defer.promise

GroupUploadDataService.$inject = [
  '$http'
  '$q'
]

module.exports = GroupUploadDataService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-upload-data-service.coffee